import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty, isNil } from 'lodash';
import FilePreview from './FilePreview';
var FilePreviewWrapper = function FilePreviewWrapper(_ref) {
  var uploadedFiles = _ref.uploadedFiles;
  return /*#__PURE__*/React.createElement("div", {
    className: "file-upload-dropzone__preview"
  }, !isEmpty(uploadedFiles) && uploadedFiles.map(function (file) {
    var _file$file, _file$file2;
    var isNewAttachment = !isNil(file.tempId);
    var id = isNewAttachment ? file.tempId : file === null || file === void 0 ? void 0 : file.id;
    var contentType = isNewAttachment ? file === null || file === void 0 || (_file$file = file.file) === null || _file$file === void 0 ? void 0 : _file$file.type : file === null || file === void 0 ? void 0 : file.content_type;
    var preview = isNewAttachment ? file === null || file === void 0 ? void 0 : file.preview : file === null || file === void 0 ? void 0 : file.pdf_url;
    var name = isNewAttachment ? file === null || file === void 0 || (_file$file2 = file.file) === null || _file$file2 === void 0 ? void 0 : _file$file2.name : file === null || file === void 0 ? void 0 : file.filename;
    return /*#__PURE__*/React.createElement("div", {
      key: id,
      className: "file-upload-dropzone__preview__preview-item"
    }, /*#__PURE__*/React.createElement(FilePreview, {
      contentType: contentType,
      preview: preview
    }), /*#__PURE__*/React.createElement("div", {
      className: "file-upload-dropzone__preview__file-name"
    }, name));
  }));
};
FilePreview.propTypes = {
  getRootProps: PropTypes.object,
  uploadedFiles: PropTypes.array
};
FilePreview.defaultProps = {
  getRootProps: {},
  uploadedFiles: []
};
export default FilePreviewWrapper;
//# sourceMappingURL=FilePreviewWrapper.js.map